var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2C6.88 2 4.75 4.13 4.75 6.75C4.75 9.32 6.76 11.4 9.38 11.49C9.46 11.48 9.54 11.48 9.6 11.49C9.62 11.49 9.63 11.49 9.65 11.49C9.66 11.49 9.66 11.49 9.67 11.49C12.23 11.4 14.24 9.32 14.25 6.75C14.25 4.13 12.12 2 9.5 2Z",
    fill: "url(#paint0_linear_5984_4598)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.58 14.1499C11.79 12.2899 7.23996 12.2899 4.42996 14.1499C3.15996 14.9999 2.45996 16.1499 2.45996 17.3799C2.45996 18.6099 3.15996 19.7499 4.41996 20.5899C5.81996 21.5299 7.65996 21.9999 9.49996 21.9999C11.34 21.9999 13.18 21.5299 14.58 20.5899C15.84 19.7399 16.54 18.5999 16.54 17.3599C16.53 16.1299 15.84 14.9899 14.58 14.1499Z",
    fill: "url(#paint1_linear_5984_4598)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.49 7.3401C20.65 9.2801 19.27 10.9801 17.36 11.2101C17.35 11.2101 17.35 11.2101 17.34 11.2101H17.31C17.25 11.2101 17.19 11.2101 17.14 11.2301C16.17 11.2801 15.28 10.9701 14.61 10.4001C15.64 9.4801 16.23 8.1001 16.11 6.6001C16.04 5.7901 15.76 5.0501 15.34 4.4201C15.72 4.2301 16.16 4.1101 16.61 4.0701C18.57 3.9001 20.32 5.3601 20.49 7.3401Z",
    fill: "url(#paint2_linear_5984_4598)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49 16.5899C22.41 17.5599 21.79 18.3999 20.75 18.9699C19.75 19.5199 18.49 19.7799 17.24 19.7499C17.96 19.0999 18.38 18.2899 18.46 17.4299C18.56 16.1899 17.97 14.9999 16.79 14.0499C16.12 13.5199 15.34 13.0999 14.49 12.7899C16.7 12.1499 19.48 12.5799 21.19 13.9599C22.11 14.6999 22.58 15.6299 22.49 16.5899Z",
    fill: "url(#paint3_linear_5984_4598)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5984_4598",
    x1: 9.5,
    y1: 2,
    x2: 9.5,
    y2: 11.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5984_4598",
    x1: 9.49996,
    y1: 12.7549,
    x2: 9.49996,
    y2: 21.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5984_4598",
    x1: 17.5563,
    y1: 4.05664,
    x2: 17.5563,
    y2: 11.2353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5984_4598",
    x1: 18.4954,
    y1: 12.4995,
    x2: 18.4954,
    y2: 19.7522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityActive);
export default __webpack_public_path__ + "static/media/communityActive.9e1c247a422330c336d9df2421651f98.svg";
export { ForwardRef as ReactComponent };